import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class comprobanteService {

    /******* QUERIES ******/

    async paginacion(filter) {
        
        const response = await axios
            .get(`${ERP}logistica/registro-compra/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/registro-compra/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/registro-compra/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ple(filter) {
        const response = await axios
            .get(`${ERP}logistica/registro-compra/ple?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new comprobanteService();